import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import ClassAgeGroupModal from './ClassAgeGroupModal';

const ClassAgeGroup = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [ageGroups, setAgeGroups] = useState([
        // Sample data (replace with actual data)
        { minAge: 18, maxAge: 25, status: 'Active' },
        { minAge: 26, maxAge: 35, status: 'Deactive' },
        { minAge: 36, maxAge: 50, status: 'Active' },
    ]);
    const [filteredAgeGroups, setFilteredAgeGroups] = useState(ageGroups);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = ageGroups.filter((group) =>
            Object.values(group).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredAgeGroups(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, ageGroups]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAgeGroups.length / itemsPerPage);
    const currentData = filteredAgeGroups.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setAgeGroups((prevGroups) =>
            prevGroups.map((group, i) =>
                i === index
                    ? { ...group, status: group.status === 'Active' ? 'Deactive' : 'Active' }
                    : group
            )
        );
    };

    const handleDelete = (index) => {
        const updatedData = currentData.filter((_, i) => i !== index);
        setAgeGroups(updatedData);
    };

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Class age group</h1>

                {/* Add Fees Button */}
                <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                    Add age group
                </button>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Age Groups Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Minimum Age</th>
                            <th>Maximum Age</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((group, index) => (
                                <tr key={index}>
                                    <td>{group.minAge}</td>
                                    <td>{group.maxAge}</td>
                                    <td>
                                        <button onClick={() => toggleStatus(index)}>
                                            <i
                                                className={`fa ${group.status === 'Active'
                                                    ? 'fa-toggle-on'
                                                    : 'fa-toggle-off'
                                                    }`}
                                            ></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button className="edit-button" onClick={() => setIsModalOpen(true)}>
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>
                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center' }}>
                                    No age groups found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>

            <ClassAgeGroupModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default ClassAgeGroup;
